function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  colorInterpolationFilters: "auto",
  id: "atoms-icon-like-outline_inline_svg__a"
}, React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.627451 0 0 0 0 0.627451 0 0 0 0 0.627451 0 0 0 1.000000 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -1)",
  filter: "url(#atoms-icon-like-outline_inline_svg__a)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 1h16v16H0z"
}), React.createElement("path", {
  d: "M7.998 13.667a.649.649 0 00.471-.202L12.5 9.302c1.175-1.208 1.106-3.212-.202-4.33-1.135-.966-2.833-.805-3.887.282L8 5.68l-.411-.423c-.85-.879-2.565-1.408-3.888-.283-1.308 1.117-1.377 3.12-.206 4.329l4.031 4.163c.13.133.3.202.471.202zm.01-.665L3.976 8.84c-.8-.825-.966-2.398.16-3.359 1.142-.975 2.484-.269 2.976.24L8 6.64l.889-.92c.483-.5 1.837-1.208 2.975-.239 1.125.959.96 2.531.16 3.359L8.01 13.002z",
  fill: "#FFF",
  fillRule: "nonzero"
}));

function SvgAtomsIconLikeOutlineinline(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}

export default SvgAtomsIconLikeOutlineinline;